import {
  CreateOpenCommerceUserPolicy,
  UpdateOpenCommerceUserPolicy,
} from '@open-commerce/oc-authorization-policies';

import { UserAction } from './user-actions.types';

export const CreateOpenCommerceUser: UserAction = () => ({
  policy: CreateOpenCommerceUserPolicy(),
});

export const UpdateOpenCommerceUser: UserAction = () => ({
  policy: UpdateOpenCommerceUserPolicy(),
});
